module.exports = __webpack_public_path__ + "static/media/media4.511c7684.jpeg";